import fetch from '../config/api'
/**
 * 文创列表接口(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type}  1表示精品 2表示产品
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */

const culturalList = (language = '1', type = '1', num = '0', take = '10') => fetch('/wenchuang/list', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始
    take //取几条数据
});

const culturalNewsList = (language = '1', num = '0', take = '10') => fetch('/wenchuang/wenchuang_news_list', {
    p: 'wx',
    language,
    skip: num * take, //从第几个开始
    take //取几条数据
});
const culturalNewsDetail = (language = '1', wenchuang_news_id) => fetch('/wenchuang/wenchuang_news_detail', {
    p: 'wx',
    language,
    wenchuang_news_id
});

export default {
    culturalList,
    culturalNewsList,
    culturalNewsDetail
}